import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CounselorHero from "./components/CounselorHero";
import PhilosophySection from "./components/PhilosophySection";
import ApproachSection from "./components/ApproachSection";

export default function About() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <CounselorHero />
        <PhilosophySection />
        <ApproachSection />
      </main>
      <Footer />
    </div>
  );
}
